import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { parseUrlAssets } from "@ice/stark-module/lib/modules";
// import ModuleLoader from '@ice/stark-module/lib/loader';
import { execModule } from "./loader";
import { setDeps, getDeps } from "./deps";
import _get from "lodash/get";
import { getStorage } from "../utils";
import PubSub from "pubsub-js";
import { filterId } from "../utils";
var materialsConfig = {}; // 兼容配置，tagId优先级替换最高
var modulesConfig = []; // 模块方式配置信息，不指定tagId
var importModules = {}; // 缓存已加载的模块信息
var loadTask = {}; // 缓存加载任务状态

var defaultExternals = {
  react: "React",
  "react-dom": "ReactDOM",
  "@alifd/next": "Next",
  moment: "moment"
};

// export const moduleLoader = new ModuleLoader();

export var getRegisterModules = function getRegisterModules() {
  return modulesConfig;
};
export var getRegisterMaterials = function getRegisterMaterials() {
  return materialsConfig;
};
export var getImportModules = function getImportModules() {
  return importModules;
};
export var registerModules = function registerModules(configArr) {
  if (configArr === void 0) {
    configArr = [];
  }
  // 获取storage中的模块调试配置
  var debugConfig = getDebugModulesConfig();
  var configMerged = (configArr || []).concat(debugConfig).filter(function (i) {
    return i && i.name && i.url;
  }).reverse();
  if (configMerged.length < 1) {
    return modulesConfig;
  }

  // 配置去重，相同name的取索引小的值（reverse了，所以取索引小的值）
  configMerged.forEach(function (conf, idx) {
    for (var j = idx + 1, len = configMerged.length; j < len; j++) {
      if (configMerged[j] && configMerged[j].name === conf.name) {
        // @ts-ignore
        configMerged[j] = null;
      }
    }
  });
  configMerged.filter(function (i) {
    return i;
  }).reverse().forEach(function (i) {
    var idx = modulesConfig.findIndex(function (j) {
      return j.name === i.name;
    });
    if (idx !== -1) {
      modulesConfig.splice(idx, 1);

      // 删除已加载的重复模块及样式，确保获取到最新的模块信息
      if (importModules[i.name]) {
        delete importModules[i.name];
        var _parseUrlAssets = parseUrlAssets(i.url),
          _parseUrlAssets$cssLi = _parseUrlAssets.cssList,
          cssList = _parseUrlAssets$cssLi === void 0 ? [] : _parseUrlAssets$cssLi;
        removeModuleCss(cssList);
      }
    }
    modulesConfig.push(i);
  });

  // 若window全局存在模块定义但importModules中不存在，则将全局定义配置到importModules中
  modulesConfig.forEach(function (i) {
    if (i && i.url && i.name && !importModules[i.name] && window[i.name]) {
      var _parseUrlAssets2 = parseUrlAssets(i.url),
        cssList = _parseUrlAssets2.cssList;
      importModules[i.name] = {
        moduleInfo: window[i.name],
        moduleCSS: cssList
      };
    }
  });
  return modulesConfig;
};

/**
 * 物料兼容配置转换为模块配置
 * @param materialConfig
 * @returns
 */
var _materialConfig2moduleConfig = function _materialConfig2moduleConfig(conf) {
  if (validateMaterialConfig(conf)) {
    var url = [conf.assets.js, conf.assets.css].filter(function (i) {
      return i;
    }) || [];
    return url.length ? {
      name: conf.moduleInfo.library,
      url: url
    } : null;
  } else {
    return null;
  }
};

/**
 * 兼容配置方案，以 tagId 为维度
 * @param config
 */
export var registerMaterials = function registerMaterials(configs) {
  materialsConfig = Object.assign({}, materialsConfig, configs || {});

  // 读取配置中的模块包资源配置，并执行registerModules
  var ret = {};
  Object.keys(materialsConfig).forEach(function (tagId) {
    var moduleConfig = _materialConfig2moduleConfig(materialsConfig[tagId]);
    if (moduleConfig) {
      ret[moduleConfig.name] = moduleConfig;
    }
  });
  registerModules(Object.values(ret));
};

/**
 * 注册模块externals信息
 * @param config
 */
export var registerModuleExternals = function registerModuleExternals(config) {
  if (config === void 0) {
    config = {};
  }
  var deps = Object.assign({}, getDeps());
  Object.keys(config).forEach(function (k) {
    if (!config[k]) {
      return;
    }
    try {
      if (Object.prototype.toString.apply(config[k]) === "[object Object]" && config[k].root && window[config[k].root]) {
        deps[k] = window[config[k].root]; // webpack external 高级配置
      } else if (typeof config[k] === "string" && window[config[k]]) {
        deps[k] = window[config[k]]; // webpack external 简化配置
      } else if (config[k] instanceof Object) {
        deps[k] = config[k]; // 实例对象
      } else {}
    } catch (err) {}
  });
  if (Object.keys(deps).length > 0) {
    setDeps(deps);
  }
};

// 从localStorage中获取调试配置信息
export var getDebugModulesConfig = function getDebugModulesConfig() {
  var debugConfig = getStorage("__stick_debug_info");
  if (Array.isArray(debugConfig)) {
    return debugConfig.filter(function (i) {
      return i && i.name && i.url;
    });
  }
  if (debugConfig && debugConfig.name && debugConfig.url) {
    return [debugConfig];
  }
  return [];
};

/**
 * 获取追加模块样式的root节点，该节点在body内头部或body中link标签之后，为了保证扩展的样式优先级高于业务动态样式在head中
 * 如果不传id，默认head标签
 * @param id
 * @returns
 */
export var getAppendCssRoot = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (id === void 0) {
              id = "";
            }
            return _context.abrupt("return", new Promise(function (resolve) {
              if (!id) {
                return resolve(document.getElementsByTagName("head")[0]);
              }
              var rootDom = document.getElementById(id);
              if (rootDom) {
                return resolve(rootDom);
              }
              try {
                var el = document.createElement("div");
                el.id = id;
                var bodyLinks = document.body.getElementsByTagName("link") || [];
                document.body.insertBefore(el, bodyLinks.length > 0 && bodyLinks[bodyLinks.length - 1].nextSibling ? bodyLinks[bodyLinks.length - 1].nextSibling : document.body.firstChild);
                resolve(el);
              } catch (err) {
                console.error("[engine-sdk] insert root into body error.");
                resolve(document.getElementsByTagName("head")[0]);
              }
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getAppendCssRoot(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 追加模块样式文件到dom中，过滤掉已存在的moduleCSS
 * @param param0
 * @returns
 */
export var appendModuleCss = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var _ref2$moduleCSS, moduleCSS, name, links, cssList;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref2$moduleCSS = _ref2.moduleCSS, moduleCSS = _ref2$moduleCSS === void 0 ? [] : _ref2$moduleCSS, name = _ref2.name;
            if (name) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return", Promise.resolve());
          case 3:
            // 过滤掉已加载的模块样式，避免浏览器多次回流或重绘
            links = Array.from(document.getElementsByTagName("link"));
            cssList = moduleCSS.filter(function (href) {
              return links.findIndex(function (link) {
                return (link.getAttribute("href") || "").replace(/http[s]?:/g, "") === href.replace(/http[s]?:/g, "");
              }) >= 0 ? false : true;
            });
            _context2.next = 7;
            return Promise.all(cssList.map(function (css) {
              return insertModuleCss(name, css);
            }));
          case 7:
            return _context2.abrupt("return", Promise.resolve(true));
          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function appendModuleCss(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * 为了保证扩展的样式优先级高于业务动态样式（在head中），所以插入扩展样式在body内头部或body中已存在的link标签之后
 * @param name
 * @param css
 * @returns
 */
export var insertModuleCss = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(name, css) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve) {
              var element = document.createElement("link");
              element.setAttribute("module", name);
              element.rel = "stylesheet";
              element.href = css;
              element.addEventListener("error", function () {
                console.error("css asset loaded error: " + css);
                return resolve(false);
              }, false);
              element.addEventListener("load", function () {
                return resolve(true);
              }, false);
              var bodyLinks = document.body.getElementsByTagName("link") || [];
              document.body.insertBefore(element, bodyLinks.length > 0 && bodyLinks[bodyLinks.length - 1].nextSibling ? bodyLinks[bodyLinks.length - 1].nextSibling : document.body.firstChild);
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function insertModuleCss(_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var removeModuleCss = function removeModuleCss(cssList) {
  if (!cssList || cssList.length < 1) {
    return;
  }
  Array.from(document.getElementsByTagName("link")).forEach(function (link) {
    if (cssList.findIndex(function (href) {
      return href.replace(/http[?]:/g, "") === (link.getAttribute("href") || "").replace(/http[?]:/g, "");
    }) >= 0) {
      link.parentNode.removeChild(link);
    }
  });
};

// 异步加载模块，若window下已有模块定义，则从window中取并更新内存中的importModules
export var loadModule = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(config) {
    var _ref6, name, url, _parseUrlAssets3, jsList, cssList, _moduleInfo, _importModules$name, moduleInfo, moduleCSS, errMsg, mount, unmount, component;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _ref6 = config || {}, name = _ref6.name, url = _ref6.url;
            if (!(!name || !url)) {
              _context4.next = 3;
              break;
            }
            return _context4.abrupt("return", Promise.reject(new Error("Module required parameters missing")));
          case 3:
            if (importModules[name]) {
              _context4.next = 9;
              break;
            }
            _parseUrlAssets3 = parseUrlAssets(url), jsList = _parseUrlAssets3.jsList, cssList = _parseUrlAssets3.cssList; // const moduleInfo = await moduleLoader.execModule({ name, url: jsList });
            _context4.next = 7;
            return execModule({
              name: name,
              url: jsList
            });
          case 7:
            _moduleInfo = _context4.sent;
            importModules[name] = {
              moduleInfo: _moduleInfo,
              moduleCSS: cssList
            };
          case 9:
            _importModules$name = importModules[name], moduleInfo = _importModules$name.moduleInfo, moduleCSS = _importModules$name.moduleCSS;
            if (moduleInfo) {
              _context4.next = 14;
              break;
            }
            errMsg = "load or exec module failed";
            console.error(errMsg);
            return _context4.abrupt("return", Promise.reject(new Error(errMsg)));
          case 14:
            mount = config && config.mount ? config.mount : moduleInfo.mount;
            unmount = config && config.unmount ? config.unmount : moduleInfo.unmount;
            component = moduleInfo["default"] || null; // 重命名 default 导出
            _context4.prev = 17;
            _context4.next = 20;
            return appendModuleCss({
              moduleCSS: moduleCSS,
              name: name
            });
          case 20:
            _context4.next = 25;
            break;
          case 22:
            _context4.prev = 22;
            _context4.t0 = _context4["catch"](17);
            console.error("append css failed");
          case 25:
            return _context4.abrupt("return", _extends({}, moduleInfo, {
              mount: mount,
              unmount: unmount,
              component: component
            }));
          case 26:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[17, 22]]);
  }));
  return function loadModule(_x5) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * 根据config获取模块信息
 * @param config
 * @returns
 */
var _getModuleByConfig = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(config) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return loadModule(config);
          case 3:
            return _context5.abrupt("return", _context5.sent);
          case 6:
            _context5.prev = 6;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", Promise.resolve(null));
          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 6]]);
  }));
  return function _getModuleByConfig(_x6) {
    return _ref7.apply(this, arguments);
  };
}();

/**
 * 根据config和唯一标识获取模块实现
 * @param config
 * @param id
 * @param type
 * @returns
 */
export var getModuleByConfigAndId = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(config, id, type) {
    var _ref9, name, url, configKey, cb, mod;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (type === void 0) {
              type = "mixed";
            }
            id = filterId(id);

            // materialsConfig中指定了tagId对应的包及内置模块名，则优先采用指定包中的内置模块
            if (id && validateMaterialConfig(materialsConfig[id])) {
              config = _materialConfig2moduleConfig(materialsConfig[id]);
            }
            _ref9 = config || {}, name = _ref9.name, url = _ref9.url; // 若目标模块中缺少必要模块配置，或混合模式（一个扩展包中含多个模块）中缺少指定模块id，则返回null
            if (!(!name || !url || type === "mixed" && !id)) {
              _context6.next = 6;
              break;
            }
            return _context6.abrupt("return", Promise.resolve(null));
          case 6:
            configKey = "loadModuleConfig_" + JSON.stringify(config);
            cb = function cb(mod) {
              if ("mixed" === type) {
                // 混合模式，扩展入口导出标准详见：https://yuque.alibaba-inc.com/visualization_and_intelligent/bg3xzt/grgnp8#kvTEH
                if (validateMaterialConfig(materialsConfig[id])) {
                  // 通过materialsConfig配置获取模块
                  var moduleName = _get(materialsConfig, "[" + id + "].moduleInfo.moduleName");
                  return _get(mod, "component[" + moduleName + "]", null);
                }
                if (_get(mod, "modsConf.tagModuleMap[" + id + "]")) {
                  // 通过内部模块与唯一标识对应关系配置获取模块
                  var _moduleName = _get(mod, "modsConf.tagModuleMap[" + id + "]");
                  return _get(mod, "component[" + _moduleName + "]", null);
                }

                // 如果上述配置都没找到，则直接在导出的模块信息中寻找对应 id 的实现
                return _get(mod, "component[" + id + "]", null) || _get(mod, "" + id, null);
              } else {
                // 单个模块导出模式，入口 export default 导出模块实现
                return _get(mod, "component", null);
              }
            }; // 通过pubSub模式以及loadTask，避免同时加载相同的模块信息
            if (!(["loading", "loaded"].indexOf(loadTask[configKey]) === -1)) {
              _context6.next = 15;
              break;
            }
            loadTask[configKey] = "loading";
            _context6.next = 12;
            return _getModuleByConfig(config);
          case 12:
            mod = _context6.sent;
            loadTask[configKey] = "loaded";
            PubSub.publish(configKey, mod);
          case 15:
            return _context6.abrupt("return", new Promise(function (resolve, reject) {
              if (loadTask[configKey] === "loading") {
                PubSub.subscribe(configKey, function (msg, mod) {
                  resolve(cb(mod) || null);
                });
              } else {
                // 已经加载完成并被缓存起来，重新loadModule会从缓存中获取
                _getModuleByConfig(config).then(function (mod) {
                  resolve(cb(mod) || null);
                })["catch"](reject);
              }
            }));
          case 16:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return function getModuleByConfigAndId(_x7, _x8, _x9) {
    return _ref8.apply(this, arguments);
  };
}();

/**
 * 根据ID获取某个模块信息
 * @param dataId
 * @returns
 */
export var getRegistryModuleById = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id, type) {
    var module, i, len, mod, arr;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (id === void 0) {
              id = "";
            }
            if (type === void 0) {
              type = "mixed";
            }
            id = filterId(id);
            if (id) {
              _context7.next = 5;
              break;
            }
            return _context7.abrupt("return", Promise.resolve(null));
          case 5:
            if (!validateMaterialConfig(materialsConfig[id])) {
              _context7.next = 9;
              break;
            }
            _context7.next = 8;
            return getModuleByConfigAndId(_materialConfig2moduleConfig(materialsConfig[id]), id, type);
          case 8:
            return _context7.abrupt("return", _context7.sent);
          case 9:
            module = null;
            if (!(type === "mixed")) {
              _context7.next = 21;
              break;
            }
            i = 0, len = modulesConfig.length;
          case 12:
            if (!(i < len)) {
              _context7.next = 20;
              break;
            }
            _context7.next = 15;
            return getModuleByConfigAndId(modulesConfig[i], id, type);
          case 15:
            mod = _context7.sent;
            if (mod) {
              module = mod;
            }
          case 17:
            i++;
            _context7.next = 12;
            break;
          case 20:
            return _context7.abrupt("return", module);
          case 21:
            arr = modulesConfig.filter(function (i) {
              return i && i.name === id;
            }); // 加载注册重复的最后的模块
            _context7.next = 24;
            return getModuleByConfigAndId(arr[arr.length > 0 ? arr.length - 1 : 0], "", type);
          case 24:
            return _context7.abrupt("return", _context7.sent);
          case 25:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return function getRegistryModuleById(_x10, _x11) {
    return _ref10.apply(this, arguments);
  };
}();

/**
 * 根据Schema.pageId获取需要的页面模块包信息，适用于schema场景
 * @param pageId
 * @returns
 */
export var getRegistryModulesByPageId = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(pageId) {
    var module, _loop, i, len;
    return _regeneratorRuntime.wrap(function _callee8$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (pageId === void 0) {
              pageId = "";
            }
            if (pageId) {
              _context9.next = 3;
              break;
            }
            return _context9.abrupt("return", Promise.resolve(null));
          case 3:
            module = null; // 循环遍历注册的模块，找到对应页面schema的模块包
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i, len) {
              var configKey, mod;
              return _regeneratorRuntime.wrap(function _loop$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      _context8.prev = 0;
                      configKey = "loadModuleConfig_" + JSON.stringify(modulesConfig[i]);
                      if (!(["loading", "loaded"].indexOf(loadTask[configKey]) === -1)) {
                        _context8.next = 9;
                        break;
                      }
                      loadTask[configKey] = "loading";
                      _context8.next = 6;
                      return _getModuleByConfig(modulesConfig[i]);
                    case 6:
                      mod = _context8.sent;
                      loadTask[configKey] = "loaded";
                      PubSub.publish(configKey, mod);
                    case 9:
                      _context8.next = 11;
                      return new Promise(function (resolve, reject) {
                        if (loadTask[configKey] === "loading") {
                          PubSub.subscribe(configKey, function (msg, mod) {
                            resolve(mod && _get(mod, "schema." + pageId) ? mod : module);
                          });
                        } else {
                          _getModuleByConfig(modulesConfig[i]).then(function (mod) {
                            resolve(mod && _get(mod, "schema." + pageId) ? mod : module);
                          })["catch"](reject);
                        }
                      });
                    case 11:
                      module = _context8.sent;
                      _context8.next = 16;
                      break;
                    case 14:
                      _context8.prev = 14;
                      _context8.t0 = _context8["catch"](0);
                    case 16:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, _loop, null, [[0, 14]]);
            });
            i = 0, len = modulesConfig.length;
          case 6:
            if (!(i < len)) {
              _context9.next = 11;
              break;
            }
            return _context9.delegateYield(_loop(i, len), "t0", 8);
          case 8:
            i++;
            _context9.next = 6;
            break;
          case 11:
            return _context9.abrupt("return", Promise.resolve(module));
          case 12:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee8);
  }));
  return function getRegistryModulesByPageId(_x12) {
    return _ref11.apply(this, arguments);
  };
}();

/**
 * 校验模块实例信息
 * @param moduleInfo
 * @returns
 */
export var validateModuleInfo = function validateModuleInfo(moduleInfo) {
  return moduleInfo && (moduleInfo.component || moduleInfo["default"]);
};

/**
 * 校验模块配置
 * @param moduleConfig
 * @returns
 */
export var validateModuleConfig = function validateModuleConfig(moduleConfig) {
  return moduleConfig && moduleConfig.name && moduleConfig.url ? true : false;
};

/**
 * 校验 materialConfig 配置
 * @param conf
 * @returns
 */
export var validateMaterialConfig = function validateMaterialConfig(conf) {
  var _ref12 = conf || {},
    moduleInfo = _ref12.moduleInfo,
    assets = _ref12.assets;
  return moduleInfo && moduleInfo.library && assets && assets.js;
};

// 执行默认的模块externals，也可以在业务中主动调用
registerModuleExternals(defaultExternals);